import { render, staticRenderFns } from "./AddActivities.vue?vue&type=template&id=d8fe923c&"
import script from "./AddActivities.vue?vue&type=script&lang=js&"
export * from "./AddActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports